export const createBatchReleases = ({ batchid }) => {
    return [
        {
            __typename: "PhotoReleaseType",
            id: "4",
            contentType: "image/jpeg",
            originalFilename: "image1.jpeg",
            batchId: batchid,
            downloadUrl:
                "https://s3.amazonaws.com/photo-uploads.test.thenounproject.com/user-634676/releases/2023/2/5474a1b3-d65e-480f-bfe5-30be99e54449.jpeg?AWSAccessKeyId=AKIAUVIUL2SYMP6LHEDR&Signature=AaLQNR1W%2BSgj1y546TEpT8OyVqA%3D&Expires=1709135060"
        },
        {
            __typename: "PhotoReleaseType",
            id: "3",
            contentType: "image/jpeg",
            originalFilename: "image1.jpeg",
            batchId: batchid,
            downloadUrl:
                "https://s3.amazonaws.com/photo-uploads.test.thenounproject.com/user-634676/releases/2023/2/9ab4dcc3-7a6a-4bd5-832c-4bdf4a94aa44.jpeg?AWSAccessKeyId=AKIAUVIUL2SYMP6LHEDR&Signature=ZafIytiiT8UF5dhPMF9k2KAbozM%3D&Expires=1709135060"
        }
    ];
};
